angular
  .module("myApp")
  .controller(
    "ProjectApplicationFormController",
    function (
      uuiData,
      $filter,
      $scope,
      $state,
      $controller,
      $stateParams,
      $q,
      $http,
      $timeout,
      Upload,
      Notification,
      Codifiers,
      Dialog,
      PieteikumsSubmit,
      PpSaveMaindata,
      PpSaveDescription,
      PpSaveIstenosana,
      PpSaveLaikaGrafiks,
      PpAddPartner,
      PpEditPartner,
      PpRemovePartner,
      PpEditDarbiba,
      PpRemoveDarbiba,
      PpEditPublicitate,
      PpRemovePublicitate,
      PpEditProjekts,
      PpRemoveProjekts,
      PpEditRisks,
      PpRemoveRisks,
      PpEditAdrese,
      PpRemoveAdrese,
      PpSaveValsts,
      PpSaveUzturesana,
      PpSaveRaditaji,
      PpSaveSaimnFinansejumaPlans,
      PpSaveFinansejumaPlans,
      PpSaveBudzetaKopsavilkums,
      PpDelete,
      PpAttachFile,
      PpLzpAttachFile,
      PpLzpMaksajumuGrafiksSave,
      PpLzpMaksajumuGrafiksRemove,
      PpRemoveAttachment,
      PpSetAttachmentVisibility,
      PpExpertAttachFile,
      PpExpertRemoveAttachment,
      PpSendLietvediba,
      PpReject,
      PpUserImprove,
      PieteikumsUnsubmit,
      PpUserUndoSubmit,
      PpAccept,
      PpImprove,
      PpPromote,
      PpSetInactive,
      PpRelock,
      PpGrantAccess,
      PpRevokeAccess,

      PpVidusposmsAttachFile,
      PpVidusposmsLzpAttachFile,
      PpNewVidusposms,
      PpVidusposmsLzpRemoveAttachment,

      PpGalaposmsAttachFile,
      PpGalaposmsLzpAttachFile,
      PpNewGalaposms,
      PpGalaposmsLzpRemoveAttachment
    ) {
      $controller("BaseEditController", {
        $scope: $scope,
      })

      const forceRealDate = (obj, f) => {
        if (!obj[f]) {
          obj[f] = null
        } else {
          obj[f] = moment(obj[f]).toDate()
        }
      }

      $scope.dto_view = "petniecibas_pieteikums"
      $scope.editable = false // vai pieejama pamatinformācijas labošana
      $scope.submittable = false // vai ir pieejama "iesniegt" darbība
      $scope.is_operational = false // (neskatās uz pp statusu) — vai var veikt kkādas darbības

      $scope.upload = {
        file: undefined,
        desc: undefined,
      }

      $scope.kla = Codifiers.kla
      $scope.exp = []
      $scope.iznakuma_raditaji = []

      $scope.iznakuma_gadi = [] // fillGadi()

      let dto // ielasīsies ar afterLoad, tas pats, kas $scope.dto

      this.money_limit = 0

      const smart_percentage_calc = (n, percentage) => {
        const raw = (n * percentage) / 100
        const step1 = Math.trunc(raw * 1000) / 1000
        const out = (Math.round(step1 * 100) / 100).toFixed(2)
        return out
      }

      /*
    if (smart_percentage_calc(11490.91, 6) !== "689.45") {
      console.error(`smart_percentage_calc failed: ${smart_percentage_calc(11490.91, 6)}`)
    } else {
      console.log("smart_percentage_calc ok")
    }
    */

      const fillGadi = (param_sakuma_gads) => {
        if (!dto.iznakuma_raditaja_gads_1) {
          let gadi

          const sakuma_gads = +(param_sakuma_gads || moment().format("Y"))
          if (sakuma_gads === 2017) {
            gadi = [2017, 2018, 2020, 2023]
          } else if (sakuma_gads === 2018) {
            gadi = [2018, 2019, 2021, 2023]
          } else if (sakuma_gads === 2019) {
            gadi = [2019, 2021, 2022, 2023]
          } else {
            gadi = [sakuma_gads, sakuma_gads + 1, sakuma_gads + 2, sakuma_gads + 3]
          }
          dto.iznakuma_raditaja_gads_1 = gadi[0]
          dto.iznakuma_raditaja_gads_2 = gadi[1]
          dto.iznakuma_raditaja_gads_3 = gadi[2]
          dto.iznakuma_raditaja_gads_4 = gadi[3]
        }
      }

      const pageTitle = (n, s_) => {
        let s = s_
        if (s.length > 50) {
          let max = 47
          while (max < s.length && s[max] !== " ") max++
          s = `${s.substring(0, max)}...`
        }
        if (n) {
          const ns = n.split("/")
          return `${ns[ns.length - 1]} ${s}`
        }
        return s
      }

      const sorted_pielikumi = (pielikumi) => {
        const keys = Codifiers.kla.pielikuma_veids.map((pv) => pv.kods)
        return [...pielikumi].sort(
          (a, b) => keys.indexOf(a.pielikuma_veids) - keys.indexOf(b.pielikuma_veids)
        )
      }

      $scope.afterLoad = () => {
        dto = $scope.dto
        window.document.title = `${pageTitle(dto.numurs, dto.nosaukums)} - Postdoc`
        $scope.iznakuma_raditaji = uuiData.list("iznakuma_raditaji_list", { karta: dto.pieteikumu_karta_id })
        $scope.mobilitates_veidi = uuiData.list("mobilitates_veidi_list", { karta: dto.pieteikumu_karta_id })

        dto.flow = dto.flow_versija || dto.flow_pieteikums || dto.flow_karta || "default"

        $q.all([
          $scope.kla.$promise,
          $scope.iznakuma_raditaji.$promise,
          $scope.mobilitates_veidi.$promise,
        ]).then(() => {
          try {
            // const started = Date.now() / 1000

            this.money_limit = 192360
            if (dto.pieteikumu_karta_id >= 10) {
              this.money_limit = 130419 // šim vajadzētu nākt no kārtas pilnīgi, manuprāt
            }

            forceRealDate(dto, "pecdoktorants_iegusanas_datums")
            forceRealDate(dto, "plan_sakuma_datums")
            forceRealDate(dto, "plan_beigu_datums")

            $scope.fundamental_enabled = true
            if (dto.pieteikumu_karta_id === 6) {
              // 2025. gada otrajai kārtai tikai rūpnieciskie
              $scope.fundamental_enabled = false
            }

            dto.mobilitates_veidi_bool = {}
            dto.mobilitates_veidi.forEach((m) => {
              dto.mobilitates_veidi_bool[m.kods] = true
            })

            fillGadi(dto.sakuma_gads)
            this.js_gadi = [
              dto.sakuma_gads,
              dto.sakuma_gads + 1,
              dto.sakuma_gads + 2,
              dto.sakuma_gads + 3,
              dto.sakuma_gads + 4,
            ]

            this.updateTabVisibility()

            if (
              $state.current.name === "app.application.edit.latest" &&
              dto.apstiprinata_versija_id &&
              dto.apstiprinata_versija_id !== $stateParams.id
            ) {
              $state.go("app.application.edit", { id: dto.apstiprinata_versija_id })
              return
            }

            dto.iesniedzejs.korespondences_adrese_sakrit =
              dto.iesniedzejs.korespondences_adrese === null ||
              dto.iesniedzejs.juridiska_adrese === null ||
              dto.iesniedzejs.juridiska_adrese === dto.iesniedzejs.korespondences_adrese
            if (!dto.statuss) {
              dto.statuss = "MELNRAKSTS"
            }
            if (dto.istenosanas_ilgums) {
              dto.istenosanas_ilgums = 1 * dto.istenosanas_ilgums
            }
            if (!dto.istenosanas_ilgums) {
              dto.istenosanas_ilgums = undefined
            }

            const statuss = dto.statuss
            const ir_melnraksts = statuss.startsWith("MELNRAKSTS") || statuss === "TEHNISKIE"

            // šobrīd atbild tikai par to, vai drīkst nospiest "pieteikt izmaiņas", hmm
            $scope.is_operational =
              $scope.u.is.organization_iesniedzejs || !$scope.u.is.manager || dto.ir_lzp_ievadits
            if (dto.karta.konkurss === "1.1.1.2") {
              $scope.is_operational = false
            }
            // $scope.editable = ir_melnraksts && ($scope.u.is.organization_iesniedzejs || ($scope.u.is.manager && dto.ir_lzp_ievadits) || dto.sys_lietotajs_id === $scope.u.id)
            // $scope.submittable = ir_melnraksts && ($scope.u.is.organization_iesniedzejs || ($scope.u.is.manager && dto.ir_lzp_ievadits))
            $scope.editable =
              ir_melnraksts &&
              ($scope.u.is.organization_iesniedzejs || !$scope.u.is.manager || dto.ir_lzp_ievadits)
            $scope.submittable =
              ir_melnraksts &&
              ($scope.u.is.organization_iesniedzejs || ($scope.u.is.manager && dto.ir_lzp_ievadits))

            dto.pielikumi = sorted_pielikumi(dto.pielikumi)

            _.each($scope.kla.atbalsta_merkis, (m) => {
              const e = _.find(dto.atbalsta_merki, {
                kla_atbalsta_merkis_id: m.id,
              })
              if (e) {
                e.checked = true
              } else {
                dto.atbalsta_merki.push({
                  kla_atbalsta_merkis_id: m.id,
                  checked: false,
                })
              }
              return true
            })

            const raditaji = []
            _.each($scope.iznakuma_raditaji, (i, idx) => {
              const e = _.find(dto.darbibas_iznakuma_raditaji, {
                iznakuma_raditajs_id: i.id,
              })
              const el = {
                iznakuma_raditajs_id: i.id,
                sadala: i.sadala,
                sak_gads: dto.iznakuma_raditaja_gads_1,
                starp_gads: dto.iznakuma_raditaja_gads_2,
                plan_gads: dto.iznakuma_raditaja_gads_3,
                pecuzr_gads: dto.iznakuma_raditaja_gads_4,
                nosaukums: i.nosaukums,
                mervieniba: i.mervieniba,
                nr_p_k: idx + 1,
              }
              if (e) {
                // adjustējam gadus, ja nu gadi mainīti
                const m = {
                  [e.sak_gads]: e.sak_vertiba,
                  [e.starp_gads]: e.starp_vertiba,
                  [e.plan_gads]: e.plan_vertiba,
                  [e.pecuzr_gads]: e.pecuzr_vertiba,
                }
                el.sak_vertiba = m[dto.iznakuma_raditaja_gads_1]
                el.starp_vertiba = m[dto.iznakuma_raditaja_gads_2]
                el.plan_vertiba = m[dto.iznakuma_raditaja_gads_3]
                el.pecuzr_vertiba = m[dto.iznakuma_raditaja_gads_4]
              }
              raditaji.push(el)
            })
            dto.raditaji = raditaji
            $scope.save_backup()

            if (!dto.sfp_komersants) {
              dto.sfp_komersants = "VIDEJAIS"
            }

            // Finansējuma plāns
            dto.fp = {
              // other_custom: {
              //   nosaukums: "xxx",
              //   gadi: {
              //     2019: 1.01,
              //     2020: 2.02,
              //   }
              // }
              eraf: {},
              budget: {},
              private: {},
              other: {},
              other_saimn: {},
              other_cred: {},
              other_nat: {},
              other_nat_pamatl: {}, // 6+
              other_nat_mater: {}, // 6+
              other_nat_darbibas: {}, // 6+
              other_custom: {
                nosaukums: "Cits",
              },
              attiec: {},
              neattiec: {},
              total: {},
            }

            const nonzero = (x) => (x !== 0.0 ? x : undefined)

            const fp = dto.fp
            Object.keys(fp).forEach((sadala) => {
              fp[sadala].gadi = {}
              const p = dto.finansejuma_plans.find((p) => p.sadala === sadala)
              if (p) {
                fp[p.sadala].nosaukums = p.nosaukums // priekš other_custom
                this.js_gadi.forEach((gads) => {
                  // biome-ignore lint/suspicious/noDoubleEquals: not sure, vai kaut kur teksts nav
                  const elt = p.gadi.find((s) => s.gads == gads)
                  if (elt) {
                    fp[sadala].gadi[gads] = i(elt.vertiba)
                  }
                })
              }
            })

            this.update_fp()

            dto.sfp = {
              total: {},
              total_attiec: {},
              total_eraf: {},
              total_priv: {},
              petnieciba: {},
              petnieciba_eraf: {
                percentage: 50,
              },
              petnieciba_priv: {
                percentage: 50,
              },
              macibas: {},
              macibas_eraf: {
                percentage: 50,
              },
              macibas_priv: {
                percentage: 50,
              },
              tehnol: {},
              tehnol_eraf: {
                percentage: 0,
              },
              tehnol_priv: {
                percentage: 100,
              },
              neattiec: {},
            }

            const sfp = dto.sfp
            Object.keys(sfp).forEach((sadala) => {
              sfp[sadala].gadi = {}
              const p = dto.saimn_finansejuma_plans.find((p) => p.sadala === sadala)
              if (p) {
                sfp[sadala].percentage = p.percentage
                this.js_gadi.forEach((gads) => {
                  const elt = p.gadi.find((s) => s.gads === gads)
                  if (elt) {
                    sfp[sadala].gadi[gads] = elt.vertiba
                  }
                })
              }
            })

            this.update_sfp()

            if (dto.ar_saimniecisku_darbibu_saistits) {
              dto.budget_sections = [
                "pers",
                "isten",
                "pers_alga",
                "pers_pdalga",
                "isten_mat",
                "isten_outsource",
                "isten_instrum",
                "isten_komandejumi",
                "isten_citi",
                "macibas",
                "legal",
              ]
            } else {
              dto.budget_sections = ["pers", "admin", "isten", "mob", "mob_fam", "mob_postdoc", "fam_move"]
            }

            if (dto.pieteikumu_karta_id < 6) {
              dto.budget_sections.push("nat")
              dto.budget_sections.push("nat_pamatl")
              dto.budget_sections.push("nat_mater")
              dto.budget_sections.push("nat_darbibas")
            }

            dto.budg = {
              total: {},
            }
            dto.budget_sections.forEach((s) => {
              dto.budg[s] = {}
            })
            dto.budzeta_kopsavilkums.forEach((b) => {
              if (!dto.budg[b.sadala]) {
                if (dto.attiec) {
                  console.log({
                    skipping_received_shouldnt_be_here: b.sadala,
                    attiec: b.attiec,
                    neattiec: b.neattiec,
                  })
                }
                return
              }
              dto.budg[b.sadala].daudzums = nonzero(b.daudzums)
              dto.budg[b.sadala].mervieniba = b.mervieniba
              dto.budg[b.sadala].aktiv_nr = b.aktivitates_nr
              dto.budg[b.sadala].attiec = nonzero(b.attiec)
              dto.budg[b.sadala].neattiec = nonzero(b.neattiec)
              dto.budg[b.sadala].pvn = nonzero(b.pvn)
            })

            this.update_budget(dto.budget_sections)

            {
              // no datubāzes
              const tot_00 = dto.budzeta_kopsavilkums.find((q) => q.sadala === "total")?.attiec
              // aprēķinātais
              const tot_01 = dto.budg.total.attiec
              this.budget_save_desired = (tot_00 || 0) !== (tot_01 || 0)
              if (this.budget_save_desired) {
                console.log({ budget_save_desired: true, tot_00, tot_01 })
              }
            }

            _.each(dto.darbibas, (d) => {
              // pārveido darbibas.plans uz listi ar gadiem secīgi
              const pp = d.plans || []

              d.plans_by_year = {}

              this.js_gadi.forEach((gads) => {
                // const elt = typeof pp === "object" ? pp[gads] : pp.find((f) => +f.gads === gads)
                const elt = pp.find((f) => +f.gads === gads)
                if (elt) {
                  d.plans_by_year[gads] = elt
                } else {
                  d.plans_by_year[gads] = {
                    gads,
                    q_1: false,
                    q_2: false,
                    q_3: false,
                    q_4: false,
                  }
                }
              })
            })

            dto.rezultata_raditaji.push({
              mervieniba: "Skaits",
            })

            this.lock_editing(dto.sadalas)

            if (!$scope.u.is.organization) {
              $scope.exp = uuiData.record("pp_ekspertu_info", dto.id)
              const exp = $scope.exp
              exp.$promise.then(() => {
                this.setSomeTabVisibility("lzp-eksperti", should_see_lzp_expert_tab())
                this.setSomeTabVisibility("lzp-pielikumi", should_see_lzp_expert_tab())
                this.setSomeTabVisibility("ekspertu-vertejums", exp.ekspertizes.length > 0)
                this.setSomeTabVisibility(
                  "risku-izvertejums",
                  exp.atbildigie.find((a) => a.veids === "RISKS" && a.adm_lietotajs_id === $scope.u.id)
                )
              })
            }
            // vēstuļu un līgumu sadaļu redz:
            // - LZP darbinieki — vienmēr
            // - klienti — ja līgums ir iesniegts (lai varētu ielādēt veidlapas nstuff)
            // - klienti — ja LZP darbinieki ir kaut ko ievadījuši
            if (
              dto.statuss === "IESNIEGTS" ||
              dto.statuss === "APSTIPRINATS" ||
              dto.statuss === "NEAKTUALS" ||
              $scope.u.is.manager ||
              (dto.dokumenti &&
                _.filter(dto.dokumenti, (d) => !d.statuss.startsWith("MELNRAKSTS")).length > 0)
            ) {
              this.setSomeTabVisibility("vestules", true)
            }
            // console.log({ afterload_postprocess_time_s: Date.now() / 1000 - started })
            /// AFTERLOAD ENDS HERE CAN YOU IMAGINE THE CRAZINESSS
          } catch (e) {
            console.error(e)
            setTimeout(() => {
              Notification.error(
                `Notika kļūda: lūdzu, dodiet mums par to ziņu, norādot pieteikuma numuru.<br><br>Līdz tam, pieteikumu labot nevajadzētu.<br><br>
             ${e.toString()}`
              )
            }, 500)
          }
        })
      }

      const should_see_lzp_expert_tab = () => {
        if ($scope.u.is.manager) return true
        return $scope.exp.ekspertizes.some((ekspertize) =>
          ekspertize.eksperti.some((eksperts) => eksperts.eksperts_id == $scope.u.id)
        )
      }

      $scope.locks = {}

      this.lock_editing = (sadalas) => {
        console.log({ lokk_editing: sadalas })
        const lock_some = !!sadalas

        Codifiers.kla.pp_tabs.forEach((t) => {
          if (t.never_lock || t.only_manager || t.only_admin) {
            $scope.locks[t.name] = false
          } else {
            $scope.locks[t.name] = lock_some
          }
        })

        if (sadalas) {
          sadalas.split(/ /).forEach((s) => {
            $scope.locks[s] = false
          })
        }
      }

      $scope.toggle = (n, elem) => {
        if ($scope.edit) {
          n[elem] = !n[elem]
        }
      }

      const percentize = $scope.percentize
      const percent_amt = $scope.percent_amt

      const i = (n) => {
        const normalized = String(n).replace(/,/g, ".").replace(/[ ]/g, "")
        const parsed = Number.parseFloat(normalized)
        const out = Number.isNaN(parsed) ? 0 : +parsed.toFixed(3)
        return out
      }

      const fp_update_total = (elem) => {
        let out = 0
        this.js_gadi.forEach((gads) => {
          out += i(elem.gadi[gads])
        })
        elem.total = Number(out.toFixed(2))
      }

      this.update_fp = () => {
        const fp = dto.fp
        fp_update_total(fp.eraf)
        fp_update_total(fp.budget)
        fp_update_total(fp.private)
        fp_update_total(fp.other_saimn)
        fp_update_total(fp.other_cred)
        fp_update_total(fp.other_nat_pamatl)
        fp_update_total(fp.other_nat_mater)
        fp_update_total(fp.other_nat_darbibas)

        this.js_gadi.forEach((gads) => {
          fp.other_nat.gadi[gads] =
            i(fp.other_nat_pamatl.gadi[gads]) +
            i(fp.other_nat_mater.gadi[gads]) +
            i(fp.other_nat_darbibas.gadi[gads])
        })
        fp_update_total(fp.other_nat)

        fp_update_total(fp.other_custom)

        this.js_gadi.forEach((gads) => {
          fp.other.gadi[gads] =
            i(fp.other_saimn.gadi[gads]) +
            i(fp.other_cred.gadi[gads]) +
            i(fp.other_nat.gadi[gads]) +
            i(fp.other_custom.gadi[gads])
          if (dto.ar_saimniecisku_darbibu_saistits) {
            fp.attiec.gadi[gads] = i(fp.eraf.gadi[gads]) + i(fp.private.gadi[gads])
          } else {
            fp.attiec.gadi[gads] = i(fp.eraf.gadi[gads]) + i(fp.budget.gadi[gads]) + i(fp.other.gadi[gads])
          }

          fp.total.gadi[gads] = i(fp.neattiec.gadi[gads]) + i(fp.attiec.gadi[gads])
        })

        fp_update_total(fp.other)
        fp_update_total(fp.attiec)
        fp_update_total(fp.neattiec)
        fp_update_total(fp.total)

        Object.keys(fp).forEach((k) => {
          if (k === "total") return
          if (k === "neattiec") return
          fp[k].percentage = percentize(fp[k].total, fp.attiec.total)
        })
        fp.attiec.percentage = "100"
      }

      this.update_sfp = () => {
        const sfp = dto.sfp

        fp_update_total(sfp.petnieciba)
        fp_update_total(sfp.macibas)
        fp_update_total(sfp.tehnol)

        if (dto.sfp_komersants === "LIELAIS") {
          sfp.petnieciba_eraf.percentage = dto.sfp_publisks ? 65 : 50
          sfp.macibas_eraf.percentage = dto.sfp_invaliditate ? 50 : 50
          sfp.tehnol_eraf.percentage = 0
        }
        if (dto.sfp_komersants === "VIDEJAIS") {
          sfp.petnieciba_eraf.percentage = dto.sfp_publisks ? 75 : 60
          sfp.macibas_eraf.percentage = dto.sfp_invaliditate ? 60 : 50
          sfp.tehnol_eraf.percentage = 50
        }
        if (dto.sfp_komersants === "MAZAIS") {
          sfp.petnieciba_eraf.percentage = dto.sfp_publisks ? 80 : 70
          sfp.macibas_eraf.percentage = dto.sfp_invaliditate ? 70 : 70
          sfp.tehnol_eraf.percentage = 50
        }

        if (dto.sfp_fundamentals) {
          sfp.petnieciba_eraf.percentage = 85
        }

        sfp.petnieciba_priv.percentage = 100 - sfp.petnieciba_eraf.percentage
        sfp.macibas_priv.percentage = 100 - sfp.macibas_eraf.percentage
        sfp.tehnol_priv.percentage = 100 - sfp.tehnol_eraf.percentage

        this.js_gadi.forEach((gads) => {
          sfp.petnieciba_eraf.gadi[gads] = percent_amt(
            i(sfp.petnieciba.gadi[gads]),
            sfp.petnieciba_eraf.percentage
          )
          sfp.petnieciba_priv.gadi[gads] = i(sfp.petnieciba.gadi[gads]) - sfp.petnieciba_eraf.gadi[gads]

          sfp.macibas_eraf.gadi[gads] = percent_amt(i(sfp.macibas.gadi[gads]), sfp.macibas_eraf.percentage)
          sfp.macibas_priv.gadi[gads] = i(sfp.macibas.gadi[gads]) - sfp.macibas_eraf.gadi[gads]

          sfp.tehnol_eraf.gadi[gads] = percent_amt(i(sfp.tehnol.gadi[gads]), sfp.tehnol_eraf.percentage)
          sfp.tehnol_priv.gadi[gads] = i(sfp.tehnol.gadi[gads]) - sfp.tehnol_eraf.gadi[gads]

          sfp.total_priv.gadi[gads] =
            sfp.petnieciba_priv.gadi[gads] + sfp.macibas_priv.gadi[gads] + sfp.tehnol_priv.gadi[gads]
          sfp.total_eraf.gadi[gads] =
            sfp.petnieciba_eraf.gadi[gads] + sfp.macibas_eraf.gadi[gads] + sfp.tehnol_eraf.gadi[gads]

          sfp.total_attiec.gadi[gads] = sfp.total_priv.gadi[gads] + sfp.total_eraf.gadi[gads]
          sfp.total_attiec.gadi[gads] = sfp.total_priv.gadi[gads] + sfp.total_eraf.gadi[gads]

          sfp.total.gadi[gads] = sfp.total_attiec.gadi[gads] + i(sfp.neattiec.gadi[gads])
        })
        fp_update_total(sfp.petnieciba_priv)
        fp_update_total(sfp.petnieciba_eraf)

        fp_update_total(sfp.macibas_priv)
        fp_update_total(sfp.macibas_eraf)

        fp_update_total(sfp.tehnol_priv)
        fp_update_total(sfp.tehnol_eraf)
        fp_update_total(sfp.neattiec)

        fp_update_total(sfp.total_priv)
        fp_update_total(sfp.total_eraf)

        fp_update_total(sfp.total_attiec)

        fp_update_total(sfp.total)

        sfp.total_attiec.perc_total = 100
        sfp.petnieciba.perc_total = percentize(sfp.petnieciba.total, sfp.total_attiec.total)
        sfp.macibas.perc_total = percentize(sfp.macibas.total, sfp.total_attiec.total)
        sfp.tehnol.perc_total = percentize(sfp.tehnol.total, sfp.total_attiec.total)
        sfp.total_eraf.perc_total = percentize(sfp.total_eraf.total, sfp.total_attiec.total)
        sfp.total_priv.perc_total = percentize(sfp.total_priv.total, sfp.total_attiec.total)

        if (dto.ar_saimniecisku_darbibu_saistits) {
          this.js_gadi.forEach((gads) => {
            dto.fp.eraf.gadi[gads] =
              i(sfp.petnieciba_eraf.gadi[gads]) +
              i(sfp.macibas_eraf.gadi[gads]) +
              i(sfp.tehnol_eraf.gadi[gads])
            dto.fp.private.gadi[gads] =
              i(sfp.petnieciba_priv.gadi[gads]) +
              i(sfp.macibas_priv.gadi[gads]) +
              i(sfp.tehnol_priv.gadi[gads])
            dto.fp.neattiec.gadi[gads] = i(sfp.neattiec.gadi[gads])
          })
        }
        this.update_fp()
      }

      this.update_budget = () => {
        const all = dto.budget_sections ?? []

        const b = dto.budg

        if (dto.ar_saimniecisku_darbibu_saistits) {
          /// saimnieciskais budžeta kopsavilkums

          for (const s of all) {
            b[s].attiec = i(b[s].mervieniba) * i(b[s].daudzums)
            b[s].total = i(b[s].attiec) + i(b[s].neattiec)
          }

          b.pers.attiec = i(b.pers_pdalga.attiec) + i(b.pers_alga.attiec)
          b.pers.neattiec = i(b.pers_pdalga.neattiec) + i(b.pers_alga.neattiec)
          b.pers.total = b.pers.attiec + b.pers.neattiec
          b.pers.pvn = i(b.pers_pdalga.pvn) + i(b.pers_alga.pvn)

          b.isten.attiec =
            i(b.isten_mat.attiec) +
            i(b.isten_outsource.attiec) +
            i(b.isten_instrum.attiec) +
            i(b.isten_komandejumi.attiec) +
            i(b.isten_citi.attiec)
          b.isten.neattiec =
            i(b.isten_mat.neattiec) +
            i(b.isten_outsource.neattiec) +
            i(b.isten_instrum.neattiec) +
            i(b.isten_komandejumi.neattiec) +
            i(b.isten_citi.neattiec)
          b.isten.total = b.isten.attiec + b.isten.neattiec
          b.isten.pvn =
            i(b.isten_mat.pvn) +
            i(b.isten_outsource.pvn) +
            i(b.isten_instrum.pvn) +
            i(b.isten_komandejumi.pvn) +
            i(b.isten_citi.pvn)

          b.macibas.total = i(b.macibas.attiec) + i(b.macibas.neattiec)
          b.legal.total = i(b.legal.attiec) + i(b.legal.neattiec)
          b.total.attiec = i(b.pers.attiec) + i(b.isten.attiec) + i(b.macibas.attiec) + i(b.legal.attiec)

          b.total.neattiec =
            i(b.pers.neattiec) + i(b.isten.neattiec) + i(b.macibas.neattiec) + i(b.legal.neattiec)
          b.total.pvn = i(b.pers.pvn) + i(b.isten.pvn) + i(b.macibas.pvn) + i(b.legal.pvn)
          b.total.total = b.total.attiec + b.total.neattiec
        } else {
          /// nesaimnieciskais budžeta kopsavilkums

          b.pers.total = i(b.pers.attiec) + i(b.pers.neattiec)

          if (b.pers.mervieniba === null || typeof b.pers.mervieniba === "undefined") {
            b.pers.mervieniba = "3860"
          }
          if (b.admin.mervieniba === null || typeof b.admin.mervieniba === "undefined") {
            b.admin.mervieniba = smart_percentage_calc(b.pers.mervieniba, 6)
            // b.admin.mervieniba = (b.pers.mervieniba * 0.06).toFixed(2)
          }
          if (b.isten.mervieniba === null || typeof b.isten.mervieniba === "undefined") {
            b.isten.mervieniba = "1000"
          }

          const mobilitates = [
            ["mob", Codifiers.kla.default_measures.mob[0], Codifiers.kla.default_measures.mob[1]],
            ["mob_fam", Codifiers.kla.default_measures.mob_fam[0], Codifiers.kla.default_measures.mob_fam[1]],
            [
              "mob_postdoc",
              Codifiers.kla.default_measures.mob_postdoc[0],
              Codifiers.kla.default_measures.mob_postdoc[1],
            ],
            [
              "fam_move",
              Codifiers.kla.default_measures.fam_move[0],
              Codifiers.kla.default_measures.fam_move[1],
            ],
          ]
          mobilitates.forEach(([key, mervieniba, daudzums]) => {
            if (dto.mobilitates_veidi_bool[key]) {
              if (b[key].mervieniba === null || typeof b[key].mervieniba === "undefined") {
                b[key].mervieniba = mervieniba
              }
              if (b[key].daudzums === null || typeof b[key].daudzums === "undefined") {
                b[key].daudzums = daudzums
              }
            } else {
              b[key].mervieniba = null
              b[key].daudzums = null
            }
          })
          console.log({ mobilitates, mbb: dto.mobilitates_veidi_bool })

          // Totāļi

          // attiec. visi
          let tot_attiec = 0
          let tot_neattiec = 0
          let tot_total = 0
          all.forEach((code) => {
            const x = b[code]
            x.attiec = i(x.daudzums) * i(x.mervieniba)
            x.total = i(x.attiec) + i(x.neattiec)
            tot_attiec += i(x.attiec)
            tot_neattiec += i(x.neattiec)
            tot_total += i(x.total)
          })

          all.forEach((code) => {
            const x = b[code]
            x.perc_attiec = percentize(i(x.attiec), tot_attiec)
            x.perc_total = percentize(i(x.total), tot_total)
          })

          b.total.attiec = tot_attiec
          // console.log({ tot_attiec })
          b.total.neattiec = tot_neattiec
          b.total.total = tot_total
          b.total.total = b.total.attiec + b.total.neattiec
        }
      }

      this.tabs = []

      const enrichedFlow = (dto) =>
        `${dto.flow}.${dto.ar_saimniecisku_darbibu_saistits ? "saimn" : "nesaimn"}`

      this.updateTabVisibility = () => {
        if (!this.tabs.length) {
          _.each(Codifiers.kla.pp_tabs, (t) => {
            if (t.only_manager === true && !$scope.u.is.manager) {
              // avoid
            } else if (t.only_admin === true && !$scope.u.is.admin) {
              // avoid
            } else if (t.konkurss && -1 === t.konkurss.indexOf(dto.karta.konkurss)) {
              // console.log({ avoiding: t, konkurss: dto.karta.konkurss })
              // avoid
            } else if (t.flows && !t.flows.includes(dto.flow) && !t.flows.includes(enrichedFlow(dto))) {
              // console.log({ avoiding: t, flow: dto.flow })
              // avoid
            } else {
              const tab = { ...t, visible: t.visible === undefined ? true : t.visible }
              if (dto.flow !== "default") {
                delete tab.section
              }

              this.tabs.push(tab)
            }
          })
        }
        this.tabs.forEach((t) => {
          if (t.visible_fn) {
            t.visible = t.visible_fn(dto, $scope.u)
          }
        })
      }

      this.switchToSomeTab = (tpl_part) => {
        let active_tab = null
        this.tabs.find((t, idx) => {
          if (t.name.indexOf(tpl_part) !== -1 || t.section?.indexOf(tpl_part) === 0) {
            if (t.visible) {
              active_tab = idx
              return true
            } else {
              console.log({ not_switching: t })
            }
          }
          return false
        })
        if (active_tab !== null) {
          this.active_tab = active_tab
        }
      }

      this.setSomeTabVisibility = (name, visible) => {
        _.each(this.tabs, (t) => {
          if (t.name === name) {
            t.visible = visible
          }
        })
      }

      this.tabEnter = (tab) => {
        if (tab.name) $scope.$broadcast(`enter.${tab.name}`)

        if (tab.name === "history") {
          this.onHistoryEnter()
        }
        if (tab.name === "maksajumu-grafiks") {
          this.onMaksajumuGrafiksEnter()
        }
      }

      this.reloadMaksajumuGrafiks = () => {
        uuiData.list("pp_lzp_maksajumu_grafiks_list", { pieteikums_id: dto.pieteikums_id }, (l) => {
          let tot_total = 0
          let tot_eu = 0
          let tot_budz = 0
          let tot_zi = 0
          l.forEach((e) => {
            // just mutate
            forceRealDate(e, "termins")
            forceRealDate(e, "periods_no")
            forceRealDate(e, "periods_lidz")
            tot_total += i(e.fin_total)
            tot_eu += i(e.fin_eu)
            tot_budz += i(e.fin_budz)
            tot_zi += i(e.fin_zi)
          })
          dto.maksajumu_grafiks = l
          dto.maksajumu_grafiks_totals = {
            total: tot_total,
            eu: tot_eu,
            budz: tot_budz,
            zi: tot_zi,
          }
        })
      }

      this.addLzpMaksajumuGrafiks = () => {
        return this.editLzpMaksajumuGrafiks({
          new: true,
          maksajuma_veids: "A",
          npk: `${dto.maksajumu_grafiks?.length + 1}`,
        })
      }

      this.editLzpMaksajumuGrafiks = (p) => {
        if (!$scope.u.is.manager) {
          console.log("Not a manager")
          return
        }
        // const opts = { wide: true };
        const opts = {}

        return Dialog.dialog("pages/dialogs/pp.lzp.maksajumu-grafiks.form.html", p, opts, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PpLzpMaksajumuGrafiksRemove({
                id: p.id,
                pieteikums_id: p.pieteikums_id,
              }),
              this.reloadMaksajumuGrafiks
            )
          } else if (action === "save") {
            p.pieteikums_id = dto.pieteikums_id
            return Dialog.finish(new PpLzpMaksajumuGrafiksSave(p), this.reloadMaksajumuGrafiks)
          }
        })
      }

      this.addPartner = () => {
        return this.editPartner({
          new: true,
          ir_arvalstu_partneris: false,
        })
      }

      this.addDarbiba = () => {
        return this.editDarbiba({
          new: true,
          rezultati: [{}],
        })
      }

      this.addPublicitate = () => {
        return this.editPublicitate({
          new: true,
        })
      }

      this.addProjekts = () => {
        return this.editProjekts({
          new: true,
        })
      }

      this.addRisks = () => {
        return this.editRisks({
          new: true,
        })
      }

      this.addAddress = () => {
        return this.editAddress({
          new: true,
        })
      }

      this.partnerAutocomplete = (dto) => {
        return uuiData.list(
          "pp_partneris_reg_autocomplete",
          {
            registracijas_nr: dto.registracijas_nr,
            limit: 1,
          },
          (d) => {
            if (d.length === 0) {
              return Notification.error("Neatradu organizāciju ar šādu kodu.")
            }
            dto.nosaukums = d[0].nosaukums
            dto.ir_arvalstu_partneris = d[0].ir_arvalstu_partneris
            dto.registracijas_nr = d[0].registracijas_nr
            dto.nod_registracijas_nr = d[0].nod_registracijas_nr
            dto.kla_veids_id = d[0].kla_veids_id
            dto.ir_valsts_finansets = d[0].ir_valsts_finansets
            dto.kla_galvena_nace_id = d[0].kla_galvena_nace_id
            dto.juridiska_adrese = d[0].juridiska_adrese
            dto.e_pasts = d[0].e_pasts
            dto.timekla_adrese = d[0].timekla_adrese
          }
        )
      }

      this.validatePartner = (p) => {
        const missing = []
        if (!p.nosaukums) missing.push("nosaukumu")
        if (!p.ir_arvalstu_partneris && !p.registracijas_nr) missing.push("reģistrācijas numuru")
        if (!p.kla_veids_id) missing.push("partnera veidu")
        if (!p.pamatojums) missing.push("pamatojumu")
        if (!p.e_pasts) missing.push("partnera e-pasta adresi")

        if (!p.kontaktpersona?.vards_uzvards) {
          missing.push("kontaktpersonas vārdu")
        }

        if (!p.kontaktpersona?.talrunis && !p.kontaktpersona?.e_pasts) {
          missing.push("kontaktpersonas tālruni vai e-pastu")
        }
        return missing
      }

      this.editPartner = (p) => {
        const opts = { wide: true }
        p.autocomplete = this.partnerAutocomplete

        return Dialog.dialog("pages/dialogs/pp.partner.form.html", p, opts, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(new PpRemovePartner({ id: p.id }), $scope.reload)
          } else if (action === "save") {
            p.pd_versija_id = dto.id
            const missing = this.validatePartner(p)
            if (missing.length) {
              return $q.reject(`Norādiet vēl ${missing.join(", ")}.`)
            }
            if (p.new) {
              return Dialog.finish(new PpAddPartner(p), $scope.reload)
            } else {
              return Dialog.finish(new PpEditPartner(p), $scope.reload)
            }
          }
        })
      }

      this.editDarbiba = (p_orig) => {
        const p = angular.copy(p_orig)
        p.visi_partneri = dto.partneri
        p.removeResult = function (r) {
          this.rezultati = this.rezultati.filter((e) => e !== r)
        }
        p.addResult = function () {
          this.rezultati.push({})
        }
        _.each(p.visi_partneri, (part) => {
          part.checked = !!_.find(p.iesaistitas_personas, {
            pv_partneris_id: part.id,
          })
        })
        return Dialog.dialog("pages/dialogs/pp.darbibas.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PpRemoveDarbiba({
                id: p.id,
              }),
              $scope.reload
            )
          } else if (action === "save") {
            p.pd_versija_id = dto.id
            p.iesaistitas_personas = []
            _.each(p.visi_partneri, (part) => {
              if (part.checked) {
                p.iesaistitas_personas.push({
                  pv_partneris_id: part.id,
                })
              }
              return true
            })
            p.nr_p_k = 1
            return Dialog.finish(new PpEditDarbiba(p), $scope.reload)
          }
        })
      }

      this.editPublicitate = (p) =>
        Dialog.dialog("pages/dialogs/pp.publicitate.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PpRemovePublicitate({
                id: p.id,
              }),
              $scope.reload
            )
          } else if (action === "save") {
            p.pd_versija_id = dto.id
            return Dialog.finish(new PpEditPublicitate(p), $scope.reload)
          }
        })
      this.editProjekts = (p) => {
        forceRealDate(p, "projekta_sakums")
        forceRealDate(p, "projekta_beigas")
        return Dialog.dialog("pages/dialogs/pp.projekts.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PpRemoveProjekts({
                id: p.id,
              }),
              $scope.reload
            )
          } else if (action === "save") {
            if (p.projekta_sakums > p.projekta_beigas) {
              return $q.reject("Projekta sākums ir pēc projekta beigām?")
            } else {
              p.pd_versija_id = dto.id
              p.izmaksas = i(p.izmaksas)
              return Dialog.finish(new PpEditProjekts(p), $scope.reload)
            }
          }
        })
      }
      this.editRisks = (p) => {
        Dialog.dialog("pages/dialogs/pp.risks.form.html", p, (p, action) => {
          if (action === "delete") {
            return Dialog.finish(
              new PpRemoveRisks({
                id: p.id,
              }),
              $scope.reload
            )
          } else if (action === "save") {
            p.pd_versija_id = dto.id
            return Dialog.finish(new PpEditRisks(p), $scope.reload)
          }
        })
      }
      this.editAddress = (a) =>
        Dialog.dialog("pages/dialogs/pp.istenosanas-adrese.form.html", a, (a, action) => {
          if (action === "delete") {
            return Dialog.finish(new PpRemoveAdrese({ id: a.id }), $scope.reload)
          } else if (action === "save") {
            a.pd_versija_id = dto.id
            return Dialog.finish(new PpEditAdrese(a), $scope.reload)
          }
        })
      this.setDeleted = () => {
        if (confirm("Izdzēst šo melnrakstu?")) {
          const a = new PpDelete({
            id: dto.id,
          })
          return a.$save(
            () => {
              Notification.success("Pieteikums izdzēsts.")
              return $state.go(this.goodBackState())
            },
            (e) => Notification.error(e.data)
          )
        }
      }

      $scope.save_active_tab = () => {
        const t = this.tabs[this.active_tab]
        if (t.name) {
          $scope.save(t.name)
        }
      }

      $scope.save = (part) => {
        if (part === "maindata") {
          return save_maindata()
        } else if (part === "apraksts") {
          return save_description()
        } else if (part === "rezultati") {
          // nosave
        } else if (part === "raditaji") {
          return save_raditaji()
        } else if (part === "istenosanas_vietas") {
          // nosave
        } else if (part === "partneri") {
          // nosave
        } else if (part === "istenosana") {
          return save_istenosana()
        } else if (part === "riski") {
          // nosave
        } else if (part === "projekti") {
          // nosave
        } else if (part === "uzturesana") {
          return save_uzturesana()
        } else if (part === "publicitate") {
          // nosave
        } else if (part === "valsts") {
          return save_valsts()
        } else if (part === "laika_grafiks") {
          return save_laika_grafiks()
        } else if (part === "finplans") {
          return save_finans_plans()
        } else if (part === "saimnfinplans") {
          return save_saimn_finans_plans()
        } else if (part === "budzets" || part === "budzets-saimn" || part === "budzets-nesaimn") {
          return save_budget()
        } else if (part === "attachments") {
          // nosave
        } else {
          Notification.error(`Neizdodas saglabāt sadaļu "${part}", jo kods tādu nepazīst? (programmas kļūda)`)
          $scope.edit = {}
        }
      }

      this.once_after_save = undefined

      const save_tab = (obj) =>
        obj.$save(
          () => {
            Notification.success("Izmaiņas saglabātas")
            $scope.reload()
            $scope.edit = {}
            if (this.once_after_save) {
              this.once_after_save()
            }
            this.once_after_save = undefined
          },
          (err) => {
            this.after_save = undefined
            return Notification.error(err.data ? err.data : "Datus saglabāt neizdevās.")
          }
        )

      const save_finans_plans = () => {
        const d = {
          id: dto.id,
          finansejuma_plans: [],
        }
        _.each(dto.fp, (f, k) => {
          d.finansejuma_plans.push({
            sadala: k,
            nosaukums: f.nosaukums,
            gadi: this.js_gadi
              .map((g) => ({
                gads: g,
                vertiba: i(f.gadi[g]),
              }))
              .filter((f) => f.vertiba > 0.0),
            total: f.total,
            percentage: f.percentage,
          })
        })
        return save_tab(new PpSaveFinansejumaPlans(d))
      }

      const save_saimn_finans_plans = () => {
        const d = {
          id: dto.id,
          sfp_publisks: dto.sfp_publisks,
          sfp_fundamentals: dto.sfp_fundamentals,
          sfp_invaliditate: dto.sfp_invaliditate,
          sfp_komersants: dto.sfp_komersants,
          finansejuma_plans: [],
        }
        Object.keys(dto.sfp).forEach((k) => {
          const f = dto.sfp[k]
          d.finansejuma_plans.push({
            sadala: k,
            gadi: this.js_gadi
              .map((g) => ({
                gads: g,
                vertiba: i(f.gadi[g]),
              }))
              .filter((f) => f.vertiba > 0.0),
            percentage: f.percentage,
            total: +f.total,
            perc_total: f.perc_total,
          })
        })
        save_tab(new PpSaveSaimnFinansejumaPlans(d))
        // saimn fin. plāns auto-izveido fin. plānu — pieseivojam to arī.
        return save_finans_plans()
      }

      const save_laika_grafiks = () => {
        const g = {
          id: dto.id,
          darbibas: [],
        }
        _.each(dto.darbibas, (d) => {
          const dd = {
            id: d.id,
            grafiks: [],
          }
          this.js_gadi.forEach((gads) => {
            dd.grafiks.push(d.plans_by_year[gads])
          })
          g.darbibas.push(dd)
        })
        return save_tab(new PpSaveLaikaGrafiks(g))
      }

      const save_maindata = () => {
        if (dto.iesniedzejs.korespondences_adrese_sakrit) {
          dto.iesniedzejs.korespondences_adrese = dto.iesniedzejs.juridiska_adrese
        }
        return save_tab(new PpSaveMaindata(dto))
      }

      const save_description = () => {
        return save_tab(new PpSaveDescription(dto))
      }

      const save_istenosana = () => {
        const d = {
          id: dto.id,
          istenosanas_ilgums: `${dto.istenosanas_ilgums}`,
          ppk_visparigs_apraksts: dto.ppk_visparigs_apraksts,
          ppk_atbildiga_persona: dto.ppk_atbildiga_persona,
          ppk_iekartas: dto.ppk_iekartas,
          ppk_pieredze: dto.ppk_pieredze,
          ppk_publikacijas: dto.ppk_publikacijas,
          ppk_sinergija: dto.ppk_sinergija,
          istenosanas_apraksts: dto.istenosanas_apraksts,
          arvalstu_mobilitates_ilgums: dto.arvalstu_mobilitates_ilgums,
          arvalstu_mobilitates_apraksts: dto.arvalstu_mobilitates_apraksts,
          mobilitates_veidi: $scope.mobilitates_veidi
            .filter((m) => !!dto.mobilitates_veidi_bool[m.kods])
            .map((m) => ({ mobilitates_veids_id: m.id })),
        }
        return save_tab(new PpSaveIstenosana(d))
      }

      const save_raditaji = () => {
        const d = {
          id: dto.id,
          iznakuma_raditaja_gads_1: dto.iznakuma_raditaja_gads_1,
          iznakuma_raditaja_gads_2: dto.iznakuma_raditaja_gads_2,
          iznakuma_raditaja_gads_3: dto.iznakuma_raditaja_gads_3,
          iznakuma_raditaja_gads_4: dto.iznakuma_raditaja_gads_4,
          raditaji: dto.raditaji,
          rezultata_raditaji: dto.rezultata_raditaji.filter((r) => r.vertiba && r.mervieniba && r.nosaukums),
        }
        _.each(d.raditaji, (r, idx) => {
          r.nr_p_k = idx + 1
          if (r.sak_vertiba) r.sak_vertiba = +r.sak_vertiba
          if (r.starp_vertiba) r.starp_vertiba = +r.starp_vertiba
          if (r.plan_vertiba) r.plan_vertiba = +r.plan_vertiba
          if (r.pecuzr_vertiba) r.pecuzr_vertiba = +r.pecuzr_vertiba
          r.sak_gads = dto.iznakuma_raditaja_gads_1
          r.starp_gads = dto.iznakuma_raditaja_gads_2
          r.plan_gads = dto.iznakuma_raditaja_gads_3
          r.pecuzr_gads = dto.iznakuma_raditaja_gads_4
        })
        return save_tab(new PpSaveRaditaji(d))
      }

      const save_valsts = () => {
        const d = {
          id: dto.id,
          kla_istenosanas_veids_id: dto.kla_istenosanas_veids_id, // pre-1.9
          kla_atbalsta_instr_id: dto.kla_atbalsta_instr_id, // pre-1.9
          nav_grutibas_nokluvis: dto.nav_grutibas_nokluvis,
          nav_grutibas_nav_attiec: dto.nav_grutibas_nav_attiec,
          nav_uzsakts: dto.nav_uzsakts,
          atbalsta_merki: _.filter(dto.atbalsta_merki, (m) => m.checked), // pre-1.9
          valsts_atbalsta_iemesls: dto.valsts_atbalsta_iemesls,
          darbiba_nav_eksports: dto.darbiba_nav_eksports,
        }
        return save_tab(new PpSaveValsts(d))
      }

      const save_uzturesana = () => {
        const d = {
          id: dto.id,
          rezultatu_uzturesana: dto.rezultatu_uzturesana,
          iznakuma_raditaju_ilgt: dto.iznakuma_raditaju_ilgt,
          vienlidzigas_iespejas: dto.vienlidzigas_iespejas,
          ilgtspejiga_attistiba: dto.ilgtspejiga_attistiba,
        }
        return save_tab(new PpSaveUzturesana(d))
      }

      const save_budget = () => {
        const d = {
          id: dto.id,
          budzeta_kopsavilkums: [],
        }
        _.each(dto.budg, (b, sadala) => {
          d.budzeta_kopsavilkums.push({
            sadala: sadala,
            daudzums: b.daudzums,
            mervieniba: b.mervieniba,
            aktivitates_nr: b.aktiv_nr,
            attiec: +b.attiec,
            perc_attiec: +b.perc_attiec,
            neattiec: +b.neattiec,
            total: +b.total,
            perc_total: +b.perc_total,
            pvn: +b.pvn,
          })
        })
        return save_tab(new PpSaveBudzetaKopsavilkums(d))
      }

      this.viaa_save_budget = () => {
        const d = {
          id: dto.id,
          budzeta_kopsavilkums: [],
        }
        _.each(dto.budg, (b, sadala) => {
          d.budzeta_kopsavilkums.push({
            sadala: sadala,
            daudzums: b.daudzums,
            mervieniba: b.mervieniba,
            aktivitates_nr: b.aktiv_nr,
            attiec: +b.attiec,
            perc_attiec: +b.perc_attiec,
            neattiec: +b.neattiec,
            total: +b.total,
            perc_total: +b.perc_total,
            pvn: +b.pvn,
          })
        })
        $http({ method: "POST", url: "/data/pp_viaa_save_budzeta_kopsavilkums", data: d })
          .then(() => {
            Notification.success("Veiksmīgi saglabāts.")
            $scope.reload()
          })
          .catch($scope.failing)
      }

      this.removeAttachment = (a) => {
        if (!confirm("Izdzēst failu?")) return

        const r = new PpRemoveAttachment({
          id: dto.id,
          file_id: a.id,
        })
        return r.$save(() => {
          Notification.success("Pielikums izdzēsts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.toggleAttachmentVisibility = (att, field) => {
        const dto = {
          id: att.id,
          ir_redzams_ekspertam: att.ir_redzams_ekspertam,
          ir_redzams_pieteicejam: att.ir_redzams_pieteicejam,
        }
        dto[field] = !dto[field]
        const r = new PpSetAttachmentVisibility(dto)
        return r.$save(() => {
          $scope.reload()
        }, $scope.failing)
      }

      this.removeCheckedAttachments = (prefix = "") => {
        const att = dto.pielikumi.find((n) => n.checked && n.pielikuma_veids.startsWith(prefix))
        if (att) {
          const r = new PpRemoveAttachment({
            id: dto.id,
            file_id: att.id,
          })
          r.$save(() => {
            att.checked = false
            this.removeCheckedAttachments()
          }, $scope.failing)
        } else {
          $scope.reload()
        }
      }

      this.vidusposmsLzpRemoveCheckedAttachments = () => {
        const att = dto.pielikumi.find((n) => n.checked && n.pielikuma_veids === "VIDUSPOSMS_LZP")
        if (att) {
          att.checked = false
          const r = new PpVidusposmsLzpRemoveAttachment({
            id: dto.id,
            file_id: att.id,
          })
          r.$save(this.vidusposmsLzpRemoveCheckedAttachments, $scope.failing)
        } else {
          $scope.reload()
        }
      }

      this.galaposmsLzpRemoveCheckedAttachments = () => {
        const att = dto.pielikumi.find((n) => n.checked && n.pielikuma_veids === "GALAPOSMS_LZP")
        if (att) {
          att.checked = false
          const r = new PpGalaposmsLzpRemoveAttachment({
            id: dto.id,
            file_id: att.id,
          })
          r.$save(this.galaposmsLzpRemoveCheckedAttachments, $scope.failing)
        } else {
          $scope.reload()
        }
      }

      this.removeCheckedExpertAttachments = () => {
        const att = $scope.exp.pielikumi.find((n) => n.checked)
        if (att) {
          att.checked = false
          const r = new PpExpertRemoveAttachment({
            id: dto.id,
            file_id: att.id,
          })
          r.$save(this.removeCheckedExpertAttachments, $scope.failing)
        } else {
          $scope.reload()
        }
      }

      this.valsts_atbalsts_attachment_missing = () => {
        if (!["EK", "MINIMIS"].includes(dto.valsts_atbalsta_iemesls)) {
          return false
        }
        if (dto.pielikumi.find((a) => ["VALSTS_MINIMIS", "VALSTS_STIM"].includes(a.pielikuma_veids))) {
          return false
        }
        return true
      }

      this.actual_uploader = (obj, form) => {
        $scope.upload.error = undefined
        $scope.upload.loading = true
        return Upload.upload({
          url: "./upload",
          method: "POST",
          file: $scope.upload.file,
        })
          .progress((evt) => {
            $scope.upload.progress = {
              loaded: evt.loaded,
              total: evt.total,
              percentage: percentize(evt.loaded, evt.total),
            }
          })
          .success((data) => {
            obj.id = dto.id
            obj.file_id = data.id
            obj.pielikuma_veids = $scope.upload.pielikuma_veids
            obj.apraksts = $scope.upload.desc
            return obj.$save(
              () => {
                $scope.upload = {
                  loading: false,
                }
                form?.$setPristine()
                return $scope.reload()
              },
              (e) => {
                form?.$setPristine()
                $scope.upload.loading = false
                $scope.upload.error = e.data
                Notification.error(e.data)
              }
            )
          })
          .error((data) => {
            $scope.upload.loading = false
            form?.$setPristine()
            if (data.indexOf("EntityStreamSizeException" > -1)) {
              $scope.upload.error = "Ielādējamais fails ir par lielu."
            } else {
              $scope.upload.error = data
            }
          })
      }

      this.uploadLzpAttachment = (form) => {
        const v = new PpLzpAttachFile()
        v.ir_redzams_pieteicejam = !!$scope.upload.ir_redzams_pieteicejam
        v.ir_redzams_ekspertam = !!$scope.upload.ir_redzams_ekspertam
        return this.actual_uploader(v, form)
      }

      this.uploadAttachment = (form) => {
        const v = new PpAttachFile()
        return this.actual_uploader(v, form)
      }

      this.uploadExpertAttachment = (form) => {
        const v = new PpExpertAttachFile()
        return this.actual_uploader(v, form)
      }

      this.uploadVidusposmsAttachmentUser = (form) => {
        const v = new PpVidusposmsAttachFile()
        return this.actual_uploader(v, form)
      }

      this.uploadVidusposmsAttachmentLzp = (form) => {
        const v = new PpVidusposmsLzpAttachFile()
        return this.actual_uploader(v, form)
      }

      this.uploadGalaposmsAttachmentUser = (form) => {
        const v = new PpGalaposmsAttachFile()
        return this.actual_uploader(v, form)
      }

      this.uploadGalaposmsAttachmentLzp = (form) => {
        const v = new PpGalaposmsLzpAttachFile()
        return this.actual_uploader(v, form)
      }

      this.rez_raditajs_updated = (idx) => {
        if (dto.rezultata_raditaji[idx + 1] === undefined) {
          return dto.rezultata_raditaji.push({
            mervieniba: "Skaits",
          })
        }
      }

      this.openPieteikums = (id, page) => {
        if ($scope.u.is.manager) {
          $state.go("app.submissions.edit", { id, page })
        } else {
          $state.go("app.application.edit", { id, page })
        }
      }

      this.goodBackState = () => {
        if ($scope.u.is.manager) {
          return "app.submissions.list"
        }
        return "app.application.list"
      }

      this.submitPatch = () => {
        return Dialog.dialog(
          "pages/dialogs/pp.apliecinajums-edit.form.html",
          { piezimes: dto.iesniegsanas_piezimes },
          {},
          (p, action) => {
            if (action !== "save") {
              return
            }
            if (!p.piezimes) {
              return $q.reject("Norādiet grozījumu pamatojumu.")
            }
            const pp = new PieteikumsSubmit({
              id: dto.id,
              patch_piezimes: p.piezimes,
            })
            return Dialog.finish(pp, () => {
              return $state.go(this.goodBackState(), {
                id: pp.id,
              })
            })
          }
        )
      }

      this.grantAccess = () => {
        return Dialog.dialog("pages/dialogs/pp.pieeja.form.html", {}, (p, action) => {
          if (action === "save") {
            return Dialog.finish(new PpGrantAccess({ id: dto.pieteikums_id, ...p }), $scope.reload)
          }
        })
      }

      this.revokeAccess = (a) => {
        const req = new PpRevokeAccess({ id: dto.pieteikums_id, adm_lietotajs_id: a.adm_lietotajs_id })
        return req.$save(() => {
          Notification.success(`Pieeja noņemta: ${a.vards} ${a.uzvards}.`)
          $scope.reload()
        }, $scope.failing)
      }

      this.submit = () => {
        return $http({ method: "POST", url: "/data/pp_presubmit", data: { id: $stateParams.id } })
          .then(() => {
            if (dto.statuss.startsWith("MELNRAKSTS") && dto.statuss !== "MELNRAKSTS") {
              // MELNRAKSTS-xxx
              return this.submitPatch()
            }

            return Dialog.dialog("pages/dialogs/pp.apliecinajums.form.html", {}, {}, (_p, action) => {
              if (action !== "save") {
                return
              }
              const pp = new PieteikumsSubmit({
                id: dto.id,
              })
              return Dialog.finish(pp, () => {
                $state.go(this.goodBackState(), {
                  id: pp.id,
                })
              })
            })
          })
          .catch($scope.failing)
      }

      this.sendLietvediba = () => {
        if (!confirm("Nosūtīt datus uz lietvedību?")) {
          return
        }
        const a = new PpSendLietvediba({
          id: dto.id,
        })
        return a.$save(
          () => {
            return Notification.success("Nosūtīts.")
          },
          (e) => Notification.error(e.data)
        )
      }

      this.visas_sadalas = () => {
        const out = []
        this.tabs.forEach((t) => {
          if (t.visible && !t.never_lock && !t.only_manager && !t.only_admin) {
            out.push({
              key: t.name,
              title: `${t.section} ${t.head}`,
            })
          }
        })
        return out
      }

      this.improve = () => {
        const d = {
          sadalas: {},
          visas_sadalas: this.visas_sadalas(),
          locks: $scope.locks,
        }

        d._click = (status) => {
          Codifiers.kla.pp_tabs.forEach((k) => {
            d.sadalas[k.name] = status
          })
        }
        Dialog.dialog("pages/dialogs/pp.user-improve.form.html", d, { wide: true }, (p, action) => {
          if (action === "save.vidusposms") {
            this.newVidusposms()
            return true
          }
          if (action === "save.galaposms") {
            this.newGalaposms()
            return true
          }
          if (action === "save") {
            if (!d.piezimes) {
              return $q.reject("Lūdzu, aprakstiet grozījumu pamatojumu")
            }
            const sadalas = []
            Codifiers.kla.pp_tabs.forEach((k) => {
              if (p.sadalas[k.name]) sadalas.push(k.name)
            })
            if (!sadalas.length) {
              return $q.reject("Norādiet kādu sadaļu, kuru vēlaties labot.")
            }

            const opts = {
              id: $stateParams.id,
              piezimes: d.piezimes,
              sadalas: sadalas.join(" "),
            }

            const req = new PpUserImprove(opts)

            return req.$save(() => {
              Notification.success("Tika izveidota jauna pieteikuma versija.")
              this.openPieteikums(req.id)
            }, $scope.failing)
          }
        })
      }

      // noraida konsolidētu pieteikumu
      this.reject = () => {
        if (!confirm("Vai noraidīt šo pieteikumu?")) return

        const dto = new PpReject({
          id: $stateParams.id,
          // piezimes: p.komentars
        })
        return dto.$save(() => {
          Notification.success("Pieteikums tika noraidīts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.pp_promote = () => {
        if (!confirm("Turpināt vērtēšanu, pārcelt pieteikumu pilnajā plūsmā?")) return
        const req = new PpPromote({ id: dto.id })

        return req.$save(() => {
          Notification.success("Tika izveidots jauna pieteikuma versija (kā melnraksts).")
          $scope.reload()
          // this.openPieteikums(req.id)
        }, $scope.failing)
      }

      this.pp_unsubmit = () => {
        if (!confirm("Atgriezt pieteikumu labošanas režīmā?")) return
        const pp = new PieteikumsUnsubmit({
          id: dto.id,
        })
        return pp.$save(() => {
          return $state.go(this.goodBackState(), {
            id: pp.id,
          })
        }, $scope.failing)
      }

      this.pp_user_undo_submit = () => {
        if (!confirm("Atgriezt pieteikumu labošanas režīmā?")) return
        const pp = new PpUserUndoSubmit({
          id: dto.id,
        })
        return pp.$save(() => {
          $state.go(this.goodBackState(), {
            id: pp.id,
          })
        }, $scope.failing)
      }

      // apstiprina konsolidēto pieteikumu
      this.pp_accept = () => {
        if (!confirm("Apstiprināt šo pieteikumu?")) return
        const dto = new PpAccept({ id: $stateParams.id })
        return dto.$save(() => {
          Notification.success("Pieteikums tika apstiprināts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.pp_set_inactive = () => {
        if (!confirm("Šis pieteikums netiks īstenots?")) return
        const dto = new PpSetInactive({ id: $stateParams.id })
        return dto.$save(() => {
          Notification.success("Pieteikums tika atzīmēts kā netiks-īstenots.")
          $scope.reload()
        }, $scope.failing)
      }

      this.pp_set_pabeigts = () => {
        if (!confirm("Šis pieteikums ir pabeigts?")) return
        $http({ method: "POST", url: "/data/pp_set_pabeigts", data: { id: $stateParams.id } })
          .then(() => {
            Notification.success("Pieteikums tika atzīmēts kā pabeigts.")
            $scope.reload()
          })
          .catch($scope.failing)
      }

      this.pp_set_tech = () => {
        const d = {
          sadalas: {},
          visas_sadalas: this.visas_sadalas(),
          locks: $scope.locks,
        }

        d._click = (status) => {
          Codifiers.kla.pp_tabs.forEach((k) => {
            d.sadalas[k.name] = status
          })
        }

        Dialog.dialog("pages/dialogs/pp.set-tech.form.html", d, { wide: false }, (p, _action) => {
          const sadalas = []
          this.tabs.forEach((k) => {
            if (p.sadalas[k.name]) sadalas.push(k.name)
          })
          $http({
            method: "POST",
            url: "/data/pp_set_tech",
            data: { id: dto.id, sadalas: sadalas.join(" ") },
          })
            .then(() => {
              Notification.success("Pieteikums tika nodots tehniskajiem grozījumiem.")
              $scope.reload()
            })
            .catch($scope.failing)
        })
      }
      this.pp_set_lauzts = () => {
        if (!confirm("Šis pieteikums ir lauzts?")) return
        $http({ method: "POST", url: "/data/pp_set_lauzts", data: { id: $stateParams.id } })
          .then(() => {
            Notification.success("Pieteikums tika atzīmēts kā lauzts.")
            $scope.reload()
          })
          .catch($scope.failing)
      }

      this.pp_reject = () => {
        if (!confirm("Vai noraidīt šo pieteikumu?")) return

        const dto = new PpReject({
          id: $stateParams.id,
          // piezimes: p.komentars
        })
        return dto.$save(() => {
          Notification.success("Pieteikums tika noraidīts.")
          $scope.reload()
        }, $scope.failing)
      }

      this.onMaksajumuGrafiksEnter = () => {
        this.reloadMaksajumuGrafiks()
      }

      this.onHistoryEnter = () => {
        dto.statusi = uuiData.list("pp_statusu_vesture_list", { pieteikums_id: dto.pieteikums_id }, () => {
          dto.statusi.forEach((s) => {
            s.statuss_html = $filter("formatStatuss")(s.statuss)
          })
        })
      }

      // atgriež labošanai, pavaicājot, kuras sadaļas imprūvēt
      this.pp_improve = () => {
        const d = {
          sadalas: {},
          visas_sadalas: this.visas_sadalas(),
          statuss: "MELNRAKSTS-LABOJUMS",
        }
        // padod dialogam klikšķinātāju toggles funkciju
        d._click = (status) => {
          Codifiers.kla.pp_tabs.forEach((k) => {
            d.sadalas[k.name] = status
          })
        }

        return Dialog.dialog("pages/dialogs/pp.improve.form.html", d, { wide: false }, (p) => {
          const sadalas = []
          this.tabs.forEach((k) => {
            if (p.sadalas[k.name]) sadalas.push(k.name)
          })

          if (!sadalas.length && p.statuss === "MELNRAKSTS-LABOJUMS") {
            return $q.reject("Nav norādīta neviena sadaļa, ko labot.")
          }

          const opts = {
            id: dto.id,
            sadalas: sadalas.join(" "),
            statuss: p.statuss,
          }

          const d = new PpImprove(opts)

          d.$save(() => {
            Notification.success("Pieteikums tika atgriezts labošanai, tam izveidota jauna versija.")
            $state.go("app.application.edit", { id: d.id })
          }, $scope.failing)
        })
      }

      this.relock = () => {
        const locked_sadalas = dto.sadalas.split(/ /)
        const locked = {}
        const sadalas = {}
        locked_sadalas.forEach((s) => {
          locked[s] = true
          sadalas[s] = true
        })
        const d = {
          sadalas,
          visas_sadalas: this.visas_sadalas(),
          locked,
        }
        Dialog.dialog("pages/dialogs/pp.relock.form.html", d, { wide: false }, (p, action) => {
          const sadalas = []
          Codifiers.kla.pp_tabs.forEach((k) => {
            if (p.sadalas[k.name] || locked[k.name]) sadalas.push(k.name)
          })

          if (!sadalas.length) {
            return $q.reject("Nav norādīta neviena sadaļa, ko labot.")
          }

          if (action === "save") {
            return Dialog.finish(
              new PpRelock({
                id: dto.id,
                sadalas: sadalas.join(" "),
              }),
              $scope.reload
            )
          }
        })
      }

      this.newVidusposms = () => {
        const d = new PpNewVidusposms({
          id: dto.id,
        })
        d.$save((_rr) => {
          Notification.success("Izveidota jauna versija.")
          this.openPieteikums(d.id, "vidusposms")
        }, $scope.failing)
      }

      this.newGalaposms = () => {
        const d = new PpNewGalaposms({
          id: dto.id,
        })
        d.$save((_rr) => {
          Notification.success("Izveidota jauna versija.")
          this.openPieteikums(d.id, "galaposms")
        }, $scope.failing)
      }

      this.hasCheckedAttachments = (prefix = "") =>
        dto.pielikumi.some((n) => n.pielikuma_veids.startsWith(prefix) && n.checked)
      this.hasAnyAttachments = (prefix) => dto.pielikumi.some((n) => n.pielikuma_veids.startsWith(prefix))

      this.hasCheckedExpertAttachments = () => $scope.exp.pielikumi.some((n) => n.checked)

      // biome-ignore lint/complexity/noUselessLoneBlockStatements: uzraudzības groupings
      {
        $scope.uzr_upload = {} // uzraudzības dokumenti

        this.uploadUzraudziba = () => {
          const u = $scope.uzr_upload
          u.error = undefined

          if (!u.file) {
            u.error = "Ielādējiet kādu failu."
            return
          }
          if (!u.dokumenta_grupas_kods) {
            u.error = "Norādiet arī dokumenta sadaļu."
            return
          }
          if (!u.desc) {
            u.error = "Norādiet arī kādu aprakstu."
            return
          }

          u.loading = true

          return Upload.upload({
            url: "./upload",
            method: "POST",
            file: u.file,
          })
            .progress((evt) => {
              u.progress = {
                loaded: evt.loaded,
                total: evt.total,
                percentage: percentize(evt.loaded, evt.total),
              }
            })
            .success((data) => {
              u.loading = false
              $http({
                method: "POST",
                url: "/data/add_uzraudzibas_dokuments",
                data: {
                  id: dto.pieteikums_id,
                  file_id: data.id,
                  apraksts: u.desc,
                  dokumenta_grupas_kods: u.dokumenta_grupas_kods,
                },
              })
                .then(() => {
                  document.querySelectorAll(".js-file-upload").forEach((e) => {
                    e.value = ""
                  })

                  $scope.uzr_upload = { dokumenta_grupas_kods: u.dokumenta_grupas_kods, file: null }
                  Notification.success("Uzraudzības dokuments pievienots.")
                  $scope.reload()
                })
                .catch((e) => {
                  u.loading = false
                  u.error = e.data
                  Notification.error(u.error)
                })
            })
            .error((e) => {
              u.loading = false
              u.error = e.indexOf("EntityStreamSizeException" > -1) ? "Ielādējamais fails ir par lielu." : e
              Notification.error(u.error)
            })
        }

        this.attachments = null
        this.attachmentDropdown = () => {
          if (!this.attachments) {
            const items = $scope.kla.choice_pielikumi[dto.ar_saimniecisku_darbibu_saistits] ?? []
            this.attachments = items.map((i) => {
              const name = i.name || $scope.kla.rev_pielikuma_veids[i.code]

              return {
                kods: i.code,
                nosaukums: `${i.index} ${name}`,
              }
            })
          }
          return this.attachments
        }

        this.addAttachmentOfType = (code) => {
          const p = { pielikuma_veids: code }
          const opts = {}
          return Dialog.dialog("pages/dialogs/pp.upload-attachment.form.html", p, opts, (p, action) => {
            if (action === "save") {
              const obj = new PpAttachFile()
              obj.id = dto.id
              obj.file_id = p.file_id
              obj.pielikuma_veids = p.pielikuma_veids
              obj.apraksts = p.apraksts
              return Dialog.finish(new PpAttachFile(obj), $scope.reload)
            }
          })
        }

        this.hasCheckedUzraudzibaAttachments = () => $scope.dto.uzraudzibas_dokumenti.some((n) => n.checked)

        this.removeCheckedUzraudzibaAttachments = () => {
          const att = dto.uzraudzibas_dokumenti.find((n) => n.checked)
          if (att) {
            $http({
              method: "POST",
              url: "/data/remove_uzraudzibas_dokuments",
              data: {
                id: dto.pieteikums_id,
                file_id: att.id,
              },
            })
              .then(() => {
                att.checked = false
                this.removeCheckedUzraudzibaAttachments()
              })
              .catch($scope.failing)
          } else {
            $scope.reload()
          }
        }
      }

      $scope.reload()

      if ($stateParams.page) {
        $scope.dto.$promise.then(() => {
          $timeout(() => {
            this.switchToSomeTab($stateParams.page)
          }, 200)
        })
      }

      return true
    }
  )
  .controller("UploadAttachmentFormController", function (Codifiers, $scope, Upload) {
    $scope.kla = Codifiers.kla

    $scope.upload = {
      file: undefined,
      desc: undefined,
    }

    this.doUpload = () => {
      $scope.upload.error = undefined
      $scope.upload.loading = true
      return Upload.upload({
        url: "./upload",
        method: "POST",
        file: $scope.upload.file,
      })
        .progress((evt) => {
          $scope.upload.progress = {
            loaded: evt.loaded,
            total: evt.total,
            percentage: $scope.percentize(evt.loaded, evt.total),
          }
        })
        .success((data) => {
          $scope.dto.file_id = data.id

          $scope.upload = {
            loading: false,
          }

          $scope.closeThisDialog("save")
        })
        .error((data) => {
          $scope.upload.loading = false
          if (data.indexOf("EntityStreamSizeException" > -1)) {
            $scope.upload.error = "Ielādējamais fails ir par lielu."
          } else {
            $scope.upload.error = data
          }
        })
    }
  })
